import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Bell, Search } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './AppChrome.css';

function pageTitleFromPath(pathname, t) {
  if (pathname === '/' || pathname === '/dashboard') return t('dashboard.title');
  if (pathname === '/carpools') return t('carpools.title');
  if (pathname === '/carpools/new') return t('carpools.create');
  if (/^\/carpools\/[^/]+$/.test(pathname)) return t('carpools.detailTitle');
  if (pathname === '/children') return t('children.title');
  if (/^\/schedule\/[^/]+$/.test(pathname)) return t('schedule.title');
  if (/^\/tracking\/[^/]+$/.test(pathname)) return t('tracking.title');
  if (pathname === '/invitations') return t('invitations.title');
  if (pathname === '/profile') return t('profile.settings');
  return t('common.appName');
}

function getInitials(user) {
  if (!user) return '?';
  const a = user.firstName?.[0] || '';
  const b = user.lastName?.[0] || '';
  return `${a}${b}`.toUpperCase() || '?';
}

const AppChrome = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { user } = useAuth();

  const pageTitle = useMemo(() => pageTitleFromPath(pathname, t), [pathname, t]);

  return (
    <header className="app-chrome" role="banner">
      <div className="app-chrome__title-block">
        <span className="app-chrome__context">{t('common.appContext')}</span>
        <span className="app-chrome__page">{pageTitle}</span>
      </div>
      <div className="app-chrome__search" role="search">
        <Search size={16} strokeWidth={2} aria-hidden />
        <input
          type="search"
          name="global-search"
          placeholder={t('common.globalSearchPlaceholder')}
          aria-label={t('common.search')}
          autoComplete="off"
        />
      </div>
      <div className="app-chrome__actions">
        <button type="button" className="app-chrome__icon-btn" aria-label={t('common.notifications')}>
          <Bell size={20} strokeWidth={2} />
          <span className="app-chrome__notif-dot" aria-hidden />
        </button>
        <Link to="/profile" className="app-chrome__avatar" title={t('profile.title')}>
          {user?.profilePhoto ? (
            <img src={user.profilePhoto} alt="" className="app-chrome__avatar-img" />
          ) : (
            getInitials(user)
          )}
        </Link>
      </div>
    </header>
  );
};

export default AppChrome;
